// Tile URL templates for the basemap switcher.
export const basemapTiles = {
  light:     'https://a.basemaps.cartocdn.com/light_all/{z}/{x}/{y}@2x.png',
  dark:      'https://a.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}@2x.png',
  satellite: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
};

// Travel-mode speeds (km/h) for the local turf-based isochrone fallback.
export const isochroneSpeedsKmH = { driving: 60, walking: 5, cycling: 15 };

// Catchment ring colors — light → mid → severe (brand-tuned).
export const isochroneRingColors = ['#98c262', '#e0a93a', '#d65a51'];
